module.exports = __webpack_public_path__ + "img/pay-icon-3.6c811fa0.png";